module.exports = __webpack_public_path__ + "img/Home_Mobile_02.c3c860a9.jpg";